import styled from "styled-components";
import { Button } from "../../../components/button";

export const LoginMFAContainer = styled.div`
  margin-top: 4rem;

  &, form {
    width: 100%;

    display: flex;
    flex-direction: column;
    gap: 0.75rem;
  }
`;

export const LoginMFAHeader = styled.div`
  display: flex;
  flex-direction: column;

  align-items: center;

  h3 {
    font-size: 1.25rem;
    font-weight: 600;
  }
`;

export const LoginMFAActions = styled.div`
  width: 100%;

  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 1rem;
`;

export const LoginMFAButton = styled(Button)`
  background: ${({ theme }) => theme.colors["primary-color"]};
  color: ${({ theme }) => theme.colors.white};
  margin: 0;
  width: 100%;

  &:hover {
    background: ${({ theme }) => theme.colors["secondary-color"]};
  }
`;
export const ResendButton = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  background: none;
  border: none;
  color: ${({ theme }) => theme.colors["primary-color"]};
  font-weight: 500;
  cursor: pointer;
  padding: 0;
  gap: 5px;
  margin-left: 12px;
  text-decoration: underline;
  font-size: 14px;
  
  &:hover {
    color: ${({ theme }) => theme.colors["secondary-color"]};
    text-decoration: none;
  }
`;

export const WaitMessage = styled.p`
  font-size: 0.95rem;
  font-weight: 500;
  opacity: 0.85;
  margin-top: 0.5rem;
  animation: pulseFade 1.5s ease-in-out infinite;
  color: ${({ theme }) => theme.colors["primary-color"]};
  @keyframes pulseFade {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
    100% {
      opacity: 1;
    }
  }
`;